import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {CustomFieldCollection} from './custom-field-collection';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Manufacturer} from '../manufacturer/manufacturer';
import * as classTransformer from 'class-transformer';
import {CustomField} from './custom-field';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldService {

    constructor(
        private httpClient: HttpClient,
    ) {
    }

    static buildIri(customField: CustomField): string {
        return `/cpe/manufacturers/${customField.manufacturer.id}/fields/${customField.id}`;
    }

    public loadCustomFields(manufacturer: Manufacturer): Observable<CustomFieldCollection> {
        return this.httpClient
            .get('/manufacturers/' + manufacturer.id + '/fields')
            .pipe(map((result: any) => this.hydrateCollection(result)));
    }

    public createCustomField(manufacturer: Manufacturer, name: string): Observable<CustomField> {
        const payload = {
            name: name,
        };

        return this.httpClient
            .post(
                '/manufacturers/' + manufacturer.id + '/fields',
                payload,
                {headers: {'Content-Type': 'application/ld+json'}}
            )
            .pipe(map((result: any) => classTransformer.plainToInstance(CustomField, result)));
    }

    private hydrateCollection(result: any): CustomFieldCollection {
        const collection = new CustomFieldCollection();
        collection.setTotalItems(result['totalItems']);
        collection.setCustomFields(
            result['member'].map((fieldData: any) => classTransformer.plainToInstance(CustomField, fieldData))
        );

        return collection;
    }
}
